import cn from 'classnames';
import type { TimeGridCalendarMode } from '../types';
import styles from './row-spacer.module.css';

type Properties = {
  days: Date[];
  mode: TimeGridCalendarMode;
  orderedTimezones: string[];
};

const RowSpacer = ({ days, mode, orderedTimezones }: Properties) => (
  <div className={styles['row-spacer']}>
    {orderedTimezones.map((tz) => (
      <div className={styles['time-col']} key={tz} />
    ))}
    <div className={cn({ [styles['week-grid'] ?? '']: mode === 'week' })}>
      {days.map((d) => (
        <div key={d.toISOString()} />
      ))}
    </div>
  </div>
);

export default RowSpacer;
